<div class="input-group typeahead typeahead-item">
        <ng-template #typeaheadTemplate let-item="item">
            <span>{{item.codigoIntegracaoErp}} - {{item.nome}}</span>
            <span class="badge badge-danger badge-inativo" *ngIf="isInativo(item.situacao)">Inativo</span>
            <ng-template [ngIf]="item.codigoIntegracaoErpAnterior">
                <br/>
                <small>{{item.codigoIntegracaoErpAnterior}}</small>
            </ng-template>
        </ng-template>

        <div class="input-group-prepend">
            <span class="input-group-text">{{entity?.codigoIntegracaoErp}}</span>
        </div>        
        <input
            type="text"
            class="form-control"
            #inputTypeahead

            [typeahead]="typeaheadDataSource"
            [typeaheadWaitMs]="300"
            [typeaheadItemTemplate]="typeaheadTemplate"
            typeaheadOptionField="nome"
            [typeaheadMinLength]="2"
            [typeaheadOptionsLimit]="typeaheadOptionsLimit"
            [typeaheadScrollable]="true"
            [typeaheadOptionsInScrollableView]="typeaheadOptionsInScrollableView"
            [ngModel]="typeaheadSelected"
            (ngModelChange)="typeaheadToken = $event"
            (typeaheadOnSelect)="onSelectEntity($event)"
            (typeaheadNoResults)="onChangeTypeaheadNoResults($event)"
            (typeaheadLoading)="isLoading = $event"
            [dropup]="dropup"
            [container]="container"

            (keyup)="onKeyup($event)"
            (blur)="onBlur()"
            [class.ng-invalid]="ngControl.invalid"
            [required]="required"
            [disabled]="disabled"
            [readonly]="readonly"
            autocomplete="off"
            placeholder="Digite para pesquisar...">

        <span *ngIf="isLoading">
            <i class="fas fa-spinner fa-pulse loading-indicator"></i>
        </span>            

        <div class="input-group-append">
            <button type="button" class="btn btn-light" (click)="search()" tabindex="-1" [disabled]="disabled">
                <i class="fas fa-search" aria-hidden="true"></i>
            </button>
            <button type="button" class="btn btn-light" (click)="clear()" tabindex="-1" [disabled]="disabled">
                <i class="fas fa-eraser" aria-hidden="true"></i>
            </button>

            <!-- Options -->
            <div class="btn-group btn-group-options" [class.dropup]="dropup" *ngIf="options?.hasAnyOption()">
                <button type="button" class="btn btn-light dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></button>
                <div class="dropdown-menu">
                    <a class="dropdown-item" *ngIf="options?.canSincronizarErp" (click)="sincronizarErp()">
                        <i class="fas fa-sync" aria-hidden="true"></i> Sincronizar com o ERP
                    </a>
                </div>
            </div>
        </div>
    </div>
    <p class="form-text text-muted" *ngIf="typeaheadNoResults === true">Nenhum item foi encontrado</p>

<!-- Modal de pesquisa -->
<sgt-item-filter-modal
    idModal="itemFilterModal"
    (selectEntity)="onSelectEntityModal($event)"
    [exibirDataUltimoFaturamento]="exibirDataUltimoFaturamento"
    #itemFilterModal>
</sgt-item-filter-modal>
